/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	Actor,
	ActorListResponse,
	ActorUpdateRequest,
	GetActorsParams,
	PraetoidError
} from '../models';

/**
 * Returns all actors
 * @summary Get all actors
 */
export const getActors = (params?: GetActorsParams) => {
	return customInstance<ActorListResponse>({ url: `/sync/actors`, method: 'GET', params });
};

export const getGetActorsQueryKey = (params?: GetActorsParams) => {
	return ['sync', 'actors', ...(params ? [params] : [])] as const;
};

export const getGetActorsQueryOptions = <
	TData = Awaited<ReturnType<typeof getActors>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetActorsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActors>>, TError, TData>>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetActorsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getActors>>> = () => getActors(params);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getActors>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActorsQueryResult = NonNullable<Awaited<ReturnType<typeof getActors>>>;
export type GetActorsQueryError = ErrorType<PraetoidError>;

export function useGetActors<
	TData = Awaited<ReturnType<typeof getActors>>,
	TError = ErrorType<PraetoidError>
>(
	params: undefined | GetActorsParams,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActors>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getActors>>,
					TError,
					Awaited<ReturnType<typeof getActors>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActors<
	TData = Awaited<ReturnType<typeof getActors>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetActorsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActors>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getActors>>,
					TError,
					Awaited<ReturnType<typeof getActors>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActors<
	TData = Awaited<ReturnType<typeof getActors>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetActorsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActors>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all actors
 */

export function useGetActors<
	TData = Awaited<ReturnType<typeof getActors>>,
	TError = ErrorType<PraetoidError>
>(
	params?: GetActorsParams,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getActors>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetActorsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates an actor's name and email
 * @summary Update an actor
 */
export const updateActor = (id: string, actorUpdateRequest: ActorUpdateRequest) => {
	return customInstance<Actor>({
		url: `/sync/actors/${id}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: actorUpdateRequest
	});
};

export const getUpdateActorMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateActor>>,
		TError,
		{ id: string; data: ActorUpdateRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateActor>>,
	TError,
	{ id: string; data: ActorUpdateRequest },
	TContext
> => {
	const mutationKey = ['updateActor'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateActor>>,
		{ id: string; data: ActorUpdateRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updateActor(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateActorMutationResult = NonNullable<Awaited<ReturnType<typeof updateActor>>>;
export type UpdateActorMutationBody = ActorUpdateRequest;
export type UpdateActorMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update an actor
 */
export const useUpdateActor = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateActor>>,
			TError,
			{ id: string; data: ActorUpdateRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updateActor>>,
	TError,
	{ id: string; data: ActorUpdateRequest },
	TContext
> => {
	return useMutation(getUpdateActorMutationOptions(options), queryClient);
};
